<template>
    <ul :class="{ collapsed: collapsed }">
        <li
            v-for="item in uniqueItems"
            :key="item.id"
            :title="item[col.display] ? item[col.display] : item[col.displayAlt]"
        >
            {{ item[col.display] ? item[col.display] : item[col.displayAlt] }}
        </li>
        <li
            v-if="total > 4"
            class="toggle-display-all"
        >
            <a
                href="#"
                :title="toggleText"
                @click.prevent="getAllItems()"
                >{{ toggleText }}</a
            >
        </li>
    </ul>
</template>

<script>
export default {
    name: 'ArrayTableCell',

    props: {
        items: {
            type: Array,
            default: () => [],
        },
        col: {
            type: Object,
            default: () => {},
        },
        total: {
            type: Number,
            default: () => null,
        },
        objectId: {
            type: Number,
            default: () => null,
        },
    },

    data() {
        return {
            collapsed: true,
        }
    },

    computed: {
        uniqueItems() {
            return this.items.filter((v, i, items) => {
                if (items.findIndex((item) => item.id === v.id) === i) {
                    return true
                }
                return false
            })
        },

        toggleText() {
            return this.collapsed ? `Show All (${this.total})` : 'Collapse'
        },
    },

    methods: {
        getAllItems() {
            if (this.collapsed && this.total !== this.items.length) {
                this.$emit('get-items', this.col, this.objectId)
            }
            this.collapsed = !this.collapsed
        },
    },
}
</script>

<style scoped>
.collapsed li:nth-of-type(n + 5) {
    display: none;
}

.toggle-display-all {
    display: list-item !important;
}
</style>
